// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__FOjiu","selects":"Documents_selects__2r1ka"};